import { queryOptions } from '@tanstack/react-query'
import { listCompaniesOptions, STALE } from '@/shared/api'

/**
 * Компании пользователя — ВСЕ, включая текущую (так велит контракт: поповер показывает их
 * общее число). Справочник, меняется редко.
 */
export function companiesQuery() {
  return queryOptions({
    ...listCompaniesOptions(),
    staleTime: STALE.reference,
  })
}
